import React from 'react';
import i18next from 'i18next';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import './Footer.scss';
import Application from 'Application';

class Footer extends React.Component {

    render = () => {

        return (
            <footer className="footer_section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="copyrights">
                                <div className="copyright-texts">
                                    <h4>{i18next.t('Footer.copyright')} © 2021</h4>
                                    <h4 className="copyright-bold-text">
                                        {i18next.t('Footer.madewithpassion', { brand: Application.getInstance().brand })}
                                    </h4>
                                    <h4>{i18next.t('Footer.allrightreserved')}</h4>
                                </div>
                                <div className="copyrights_social">
                                    {Application.getInstance().showSocialNetworks && <div className="icon-socials">
                                        <a href="https://twitter.com/trendex_off" target="_blank"><TwitterIcon id="icon-twitter" /></a>
                                        <a href="https://www.instagram.com/trendex_official/" target="_blank"><InstagramIcon id="icon-insta" /></a>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

        );
    }
}
export default Footer;
